// extracted by mini-css-extract-plugin
export default {"PageTitle":"z3YItntD"};